import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import GeneralUtils from '../../utilities/GeneralUtils';
import { DataTable } from 'primereact/datatable';
import DataTableUtils from '../../utilities/DataTableUtils';
import { Column } from 'primereact/column';
import CompetitionUtils from '../../utilities/CompetitionUtils';

const CompetitionCalendarViewComponent = (props) => {
    const [competition, setCompetition] = useState(null);
    const [calendarList, setCalendarList] = useState([]);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setCompetition(props?.competition);
        
        const getCalendar = async () => {
            await competitionService.getCompetitionCalendarDetails(props?.competition?.id)
                .then((_calendarList) => {
                    // console.log("calendarList: ", _calendarList);
                    setCalendarList(_calendarList);
                })
                .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getCalendar();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.competition, competitionService]);
   
    return (
        <>
            <Toast ref={toast} />
                        
            <div className='col-12 mt-3'>
                <h5 className='mb-3 font-weight-normal'>{translatedMessage("competition.calendar.title")}</h5>
                <div className='filed-label'>{translatedMessage('competition.job.startDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.startDate)}</div>
            </div>
            <div className="col-12"><div className='mt-2 mb-1 font-bold'>{translatedMessage("competition.eligibility")}</div></div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.job.submitEndDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.submitEndDate)}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.eligibilityEndDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.eligibilityEndDate)}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.eligibilityClarificationEndDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.eligibilityClarificationEndDate)}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.eligibilityClarificationResponseEndDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.eligibilityClarificationResponseEndDate)}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.eligibilityContestationEndDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.eligibilityContestationEndDate)}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.eligibilityContestationResponseEndDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.eligibilityContestationResponseEndDate)}</div>
            </div>

            <div className='col-12 mb-3'>
                <div className='flex flex-row align-items-center mb-2'>
                    <div className='font-bold'>{translatedMessage('competition.exams')}</div>
                </div>
                <div className='mb-2'>{translatedMessage('competition.exams.info')}</div>
                <DataTable
                    ref={dt}
                    value={calendarList}
                    dataKey="id"
                    paginator
                    rows={DataTableUtils.defalRowsPerPage()}
                    rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                    className="datatable-responsive pcn-datatable"
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                    emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                    sortField='examDate'
                    sortOrder={1}
                >
                    <Column
                        field="examType"
                        header={translatedMessage('competition.exam.name')}
                        sortable
                        headerStyle={{ width: '15%', minWidth: '10rem' }}
                        body={(e) => CompetitionUtils.getExamNameByType(e)}
                    />
                    <Column
                        field="examDate"
                        header={translatedMessage('competition.exam.examDate')}
                        sortable
                        headerStyle={{ width: '10%', minWidth: '10rem' }}
                        body={(e) => GeneralUtils.formatDateTime(e.examDate)}
                    />
                    <Column
                        field="resultsDate"
                        header={translatedMessage('competition.exam.resultsDate')}
                        sortable
                        headerStyle={{ width: '10%', minWidth: '10rem' }}
                        body={(e) => GeneralUtils.formatDate(e.resultsDate)}
                    />
                    <Column
                        field="contestationDate"
                        header={translatedMessage('competition.exam.contestationDate')}
                        sortable
                        headerStyle={{ width: '10%', minWidth: '10rem' }}
                        body={(e) => GeneralUtils.formatDate(e.contestationDate)}
                    />
                    <Column
                        field="contestationValidationDate"
                        header={translatedMessage('competition.exam.contestationValidationDate')}
                        sortable
                        headerStyle={{ width: '10%', minWidth: '10rem' }}
                        body={(e) => GeneralUtils.formatDate(e.contestationValidationDate)}
                    />
                    <Column
                        field="examLocation"
                        header={translatedMessage('competition.exam.examLocation')}
                        sortable
                        headerStyle={{ width: '25%', minWidth: '10rem' }}
                    />
                </DataTable>
            </div>            
        </>
    );
};

export default CompetitionCalendarViewComponent;
